import { ChangeDetectionStrategy, Component, Type } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { FieldTypeConfig, FormlyFieldConfig } from '@ngx-formly/core';
import { FieldType, FormlyFieldProps } from '@ngx-formly/material/form-field';
import { FormlyFieldInput } from '@ngx-formly/material/input';

export interface FormlyDatepicker2FieldProps extends FormlyFieldProps {
  showSpinners?: boolean;
  showSeconds?: boolean;
  minDate?: Date;
  maxDate?: Date;
  stepHour?: number;
  stepMinute?: number;
  stepSecond?: number;
  touchUi?: boolean;
  enableMeridian?: boolean;
  disableMinute?: boolean;
  hideTime?: boolean;
  color?: ThemePalette;
}

export interface FormlyInputFieldConfig
  extends FormlyFieldConfig<FormlyDatepicker2FieldProps> {
  type: 'input' | Type<FormlyFieldInput>;
}

@Component({
  selector: 'vmspdb-component-formly-datetimepicker2',
  templateUrl: './formly-datetimepicker2.component.html',
  styleUrls: ['./formly-datetimepicker2.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class FormlyDatetimepicker2Component extends FieldType<
  FieldTypeConfig<FormlyDatepicker2FieldProps>
> {}
